import { BehaviorSubject } from "rxjs"

export class ModalManager{

    modalState = new BehaviorSubject(0)

    modalType = new BehaviorSubject("register") // register, donate, pray


    getModalType = () =>  this.modalType.asObservable()
    setDonateModal = () => this.modalType.next('donate')
    setRegisterModal = () => this.modalType.next('register')
    setPrayModal = () => this.modalType.next("pray")

    open = () =>  this.modalState.next(1)
     
    close = () => {
        this.modalState.next(0)
        setTimeout(() => {
            this.modalType.next("register")
        }, 1000)
        
    }

    expand = () => this.modalState.next(2)

    get = () => this.modalState.asObservable()

    collapse = () => this.modalState.next(1)

    toggle = () => {
        let state = this.modalState.value
        switch(state){
            case 0: this.open(); break;
            case 1: this.expand(); break;
            case 2: this.collapse(); break;
            default: this.expand()
            
        }
        this.modalState.next(!this.modalState.value)
    }


}

